import { TimeStamp } from 'components/timeStamp/timeStamp.module';
import { MENU_OPTION_TYPE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import { deleteFromLs } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { menuOptions, setter } from './menu.model';
import { MenuTemplate } from './menu.template';

export class Menu {
	constructor(props) {
		setter(props);

		this.init();
		this.html = MenuTemplate(menuOptions);
	}

	triggerMenuOption(title, type, payload, menuId) {
		if (menuId === 'CHAT_SETTINGS') {
			ENGT_CHAT.get('menuClose')(undefined, true);
			ENGT_CHAT.get('showChatSettingsScreen')();
		}

		if (type === MENU_OPTION_TYPE.PATH && payload) {
			const dataPacket = { postback: payload, type, text: title };
			ENGT_CHAT.get('sendMessage')(title, { message: dataPacket });
			ENGT_CHAT.get('menuClose')(undefined, true);
		} else if (type === MENU_OPTION_TYPE.URL && payload) {
			window.open(payload, '_blank');
			ENGT_CHAT.get('menuClose')(undefined, true);
		} else if (type === MENU_OPTION_TYPE.CALLBACK && payload) {
			ENGT_CHAT.get(payload)();
			ENGT_CHAT.get('menuClose')(undefined, true);
		}
	}

	refreshChat() {
		const contentContainer = document.getElementById('engtChatContent');
		const timeStamp = new TimeStamp();
		contentContainer.innerHTML = '';
		contentContainer.appendChild(timeStamp.render());
		deleteFromLs(LS().PREV_MESSAGES);
		deleteFromLs(LS().MESSAGE_MAP);
	}

	init() {
		const webMenu = ENGT_CHAT.get('config.webMenu');
		const menuData = webMenu?.call_to_actions || [];
		if (menuData && !menuData.find((m) => m.id === 'CHAT_SETTINGS')) {
			const isIcon = menuData[0]?.icon;
			const showClearConversationHistory = ENGT_CHAT.get('config.showClearConversationHistory');
			if (showClearConversationHistory) {
				menuData.push({
					title: ENGT_CHAT.get('GENERIC_STRINGS')?.['CLEAR_CHAT_HISTORY'] || 'Clear Conversation History',
					icon: isIcon ? '💬' : '',
					type: 'callback',
					payload: 'refreshChat',
					id: 'CLEAR_CHAT_HISTORY',
				});
			}
			menuData.push({
				title: ENGT_CHAT.get('GENERIC_STRINGS')?.['CHAT_SETTINGS'] || 'Chat settings',
				icon: isIcon ? '🛠️' : '',
				type: '',
				payload: '',
				id: 'CHAT_SETTINGS',
			});
		}
		setter({
			optionsData: menuData,
			themeColor: ENGT_CHAT.get('config.themeColor'),
		});
		ENGT_CHAT.set('refreshChat', this.refreshChat);
		ENGT_CHAT.set('triggerMenuOption', this.triggerMenuOption);
	}

	render() {
		return this.html;
	}
}
